import { useSnackbar } from "../components/snackbar/snackbar"
import { Actions, useDispatch, useSelector } from "../stores/dashboard.store"
import { uploadMedia, runBlueprint, retriggerTask } from "../api-client/data"

const formatNodeValues = async (nodeValues) => {
    const media = await Promise.all(
        Object.keys(nodeValues)
            .map((x) => {
                return Object.keys(nodeValues[x]).map((j) => ({
                    node: x,
                    key: j,
                    value: nodeValues[x][j],
                }))
            })
            .flat()
            .filter((x) => typeof x?.value?.name === "string")
            .map(async (x) => {
                const mediaId = await uploadMedia(x?.value)
                return {
                    ...x,
                    value: `media:${mediaId}`,
                }
            })
    )

    const mediaValues = media.reduce((a, c) => {
        if (a[c?.node] === undefined) {
            a[c?.node] = {};
        }

        a[c?.node][c?.key] = c?.value

        return a
    }, {})

    return Object.keys(nodeValues).reduce((a, c) => {
        a[c] = Object.keys(nodeValues[c]).reduce((aa, cc) => {
            if (typeof nodeValues[c][cc]?.name === "string") {
                aa[cc] = mediaValues[c][cc];
            } else {
                aa[cc] = nodeValues[c][cc];
            }
            return aa
        }, {})
        return a
    }, {})
}

export function useRunBlueprint(specificVersionID = undefined) {
    const { activeProject } = useSelector()    
    const dispatch = useDispatch()
    const { enqueueSnackbar } = useSnackbar()
    
    const handleRequest = async (cb) => {
        dispatch(Actions.SetLoadingProjectId, activeProject?.id)

        try {
            const {data, httpStatus} = await cb()

            if (httpStatus === 200) {
                enqueueSnackbar("Queued Blueprint", { variant: "info" })
                dispatch(Actions.AddPollingTask, { taskId: data?.taskId, projectId: activeProject?.id })
            }
            if (httpStatus !== 200) {
                if (data?.code === undefined) {
                    throw Error('no code')
                }
                enqueueSnackbar("Queued Blueprint", { variant: "info" })
                dispatch(Actions.SetDashboardError, data)
            }
        } catch (e) {
            enqueueSnackbar("Error queuing blueprint - try again later", {
                variant: "error",                
            })
        }

        // SetLoadingProjectId
        // loading project id is removed in projects-nav.jsx, after the next queued
        // projects request is complete this way, we can show the loading spinner until the request is queued        
    }

    const executeBlueprint = async (nodeValues, onComplete = () => {}) => {        
        handleRequest(async () => {
            const formattedNodeValues = await formatNodeValues(nodeValues)
            const ret = runBlueprint({
                id: activeProject?.id,
                nodeValues: formattedNodeValues,
                versionId: specificVersionID,
            })
            onComplete()
            return ret
        })
    }

    const retrigger = (taskId) => {
        handleRequest(async () => {
            return retriggerTask({
                id: activeProject?.id,
                taskId: taskId,
            })
        })
    }

    return {executeBlueprint, retrigger}
}

